<script>
    import _ from 'lodash'
    import { createWidgetMixin } from 'vue-instantsearch'
    import { connectHits, connectConfigure } from 'instantsearch.js/es/connectors'

    export default {
        mixins: [
            createWidgetMixin({ connector: connectHits }),
            createWidgetMixin({ connector: connectConfigure })
        ],
        props: {
            facets: {
                type: Array,
                required: true
            },
            disjunctiveFacets: {
                type: Array,
                required: true
            },
            page: {
                type: Number,
                required: true
            },
            perPage: {
                type: Number,
                required: true
            }
        },
        computed: {
            widgetParams () {
                return {
                    searchParameters: {
                        hitsPerPage: this.perPage,
                        query: '',
                        facets: this.facets,
                        disjunctiveFacets: this.disjunctiveFacets
                    }
                }
            }
        },
        watch: {
            state () {
                this.$emit('success', {
                    data: this.getData(),
                    meta: this.getMeta()
                })
            }
        },
        methods: {
            getData () {
                return this.state ? this.state.hits : []
            },
            getMeta () {
                return {
                    page: _.chain(this.state)
                        .get('results.page', 0)
                        .thru(value => {
                            return value === 0 ? 1 : value
                        })
                        .value(),
                    from: _.chain(this.state)
                        .get('results.page', 0)
                        .thru(value => {
                            return value === 0 ? 1 : value
                        })
                        .thru(value => {
                            return (value - 1) * _.get(this.state, 'results.hitsPerPage', 0) + 1
                        })
                        .value(),
                    to: _.chain(this.state)
                        .get('results.page', 0)
                        .thru(value => {
                            return value === 0 ? 1 : value
                        })
                        .thru(value => {
                            return (value - 1) * _.get(this.state, 'results.hitsPerPage', 0) + 1
                        })
                        .thru(value => {
                            return value + _.get(this.state, 'hits', []).length - 1
                        })
                        .value(),
                    last_page: _.get(this.state, 'results.nbPages', 0),
                    per_page: _.get(this.state, 'results.hitsPerPage', 0),
                    count: _.get(this.state, 'hits', []).length,
                    total: _.get(this.state, 'results.nbHits', 0)
                }
            }
        },
        render () {
            return this.$scopedSlots.default({
                data: this.getData(),
                meta: this.getMeta(),
                clear: () => {
                    this.state.instantSearchInstance.helper.clearRefinements()
                },
                filterByQuery: query => {
                    this.state.instantSearchInstance.helper.setQueryParameter('query', query)
                },
                filterByLatlng: (latlng) => {
                    if (!latlng) return

                    this.state.instantSearchInstance.helper.setQueryParameter('aroundLatLng', `${latlng.lat}, ${latlng.lng}`)
                },
                filterByRadius: (radius) => {
                    this.state.instantSearchInstance.helper.setQueryParameter('aroundRadius', !radius ? 'all' : radius)
                },
                filterByNumeric: (key, operator, value) => {
                    this.state.instantSearchInstance.helper.addNumericRefinement(key, operator, value)
                },
                filterByBoolean: (key, value) => {
                    this.state.instantSearchInstance.helper.addNumericRefinement(key, '=', value ? 1 : 0)
                },
                filterByDisjunctiveFacet: (key, value) => {
                    this.state.instantSearchInstance.helper.addDisjunctiveFacetRefinement(key, value)
                },
                get: () => {
                    this.$emit('got')

                    // for some reason, algolias pages go: 0, 2, 3, 4, 5...
                    this.state.instantSearchInstance.helper.setQueryParameter('page', this.page <= 1 ? 0 : this.page)
                    this.state.instantSearchInstance.helper.search()
                }
            })
        }
    }
</script>
